import actions from './actions';
import axios from 'axios';
import { API_PATH } from '../../../constants';

// fetch the archetype for a given report type
const fetchArchetype = (reportType, groupId) => dispatch => {
  axios
    .get(`${API_PATH}/reporting/general_report/${reportType}/archetype`, { params: { group_id: groupId } })
    .then(response => dispatch(actions.fetchArchetypeSuccess(response.data)));
};

const fetchData =
  ({ params, reportType }) =>
  dispatch => {
    const cleanedParams = Object.entries(params).filter(([_key, value]) => value !== undefined);
    const queryString = new URLSearchParams(cleanedParams).toString();
    const url = `${API_PATH}/reporting/general_report/${reportType}/data?${queryString}`;

    if (params.file_type) {
      // The call returns a CSV file attachement. Instead of doing an axios
      // call, we redirect to the API call which will trigger the file download
      const link = document.createElement('a');
      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      dispatch(actions.fetchDataStart());
      axios.get(url).then(response => dispatch(actions.fetchDataSuccess(response.data)));
    }
  };

export default {
  fetchArchetype,
  fetchData
};
